import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  actions: {
    async findSpecificItem(_, filters) {
      if (!filters || !filters.idProduto || !filters.idContrato || !filters.idContratoVendaItem) {
        throw new Error('Os filtros idProduto, idContrato e idContratoVendaItem são obrigatórios.');
      }

      const { data } = await api.get('cadastrocontratovendaitem', { params: filters });
      return data;
    },

    async findItemsByContratoid(_, { id }) {
      if (!id) throw new Error('O ID é obrigatório.');
      const { data } = await api.get(`cadastrocontratovendaitem/id/${id}`);
      return data;
    },

    async findAllItems() {
      const { data } = await api.get('cadastrocontratovendaitem');
      return data;
    },
  },
};
